import React from 'react';

import { ContactPublisherDialog } from '@exchange-frontends/components';

/**
 * @param {object} props
 * @param {string} props.appId
 * @param {() => void} props.close
 * @param {() => void} [props.onGoBack]
 * @param {string} [props.appType]
 */
const ManageContactPublisherDialog = ({ appId, appType, close, onGoBack }) => (
  <ContactPublisherDialog
    onGoBack={onGoBack}
    close={close}
    appId={appId}
    isSupportRequest={appType === 'S2S'}
    title="Contact support team"
    description={
      'Fill out the form below to submit a support request for this solution. For Exchange related support reach out to our support team'
    }
  />
);

export default ManageContactPublisherDialog;
